module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loading', {
    attrs: {
      "show": _vm.isLoading,
      "text": "加载中"
    }
  }), _vm._v(" "), _c('top-tips'), _vm._v(" "), _c('div', {
    staticClass: "remote-panel"
  }, [_c('div', {
    staticClass: "airPanel-warp"
  }, [_c('div', {
    staticClass: "airPanel"
  }, [_c('div', {
    staticClass: "modelPanel"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.currentCmd.power == 0),
      expression: "this.currentCmd.power == 0"
    }]
  }, [_c('div', {
    staticClass: "model-icon"
  }, [(this.currentCmd.mode == 0) ? _c('i', {
    staticClass: "iconfont icon-zhileng",
    attrs: {
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (this.currentCmd.mode == 1) ? _c('i', {
    staticClass: "iconfont icon-icon09",
    attrs: {
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (this.currentCmd.mode == 2) ? _c('i', {
    staticClass: "iconfont icon-zidong",
    attrs: {
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (this.currentCmd.mode == 3) ? _c('i', {
    staticClass: "iconfont icon-caozuosongfeng",
    attrs: {
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (this.currentCmd.mode == 4) ? _c('i', {
    staticClass: "iconfont icon-chushi",
    attrs: {
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "model-txt"
  }, [(this.currentCmd.mode == 3) ? _c('div', [_vm._v("NA")]) : _c('div', [_vm._v(_vm._s(this.currentCmd.temp) + "°")])])])]), _vm._v(" "), _c('div', {
    staticClass: "other-display"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.currentCmd.power == 0),
      expression: "this.currentCmd.power == 0"
    }],
    staticClass: "other-display"
  }, [_c('div', {
    staticClass: "fengxiang"
  }, [(this.currentCmd.direct == 0) ? _c('i', {
    staticClass: "iconfont icon-jiadiansaofeng",
    attrs: {
      "alt": ""
    }
  }) : _c('i', {
    staticClass: "iconfont icon-fengxiang135",
    attrs: {
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fengliang"
  }, [(this.currentCmd.speed == 0) ? _c('i', {
    staticClass: "iconfont icon-changhongfenglizidong",
    attrs: {
      "alt": ""
    }
  }) : (this.currentCmd.speed == 1) ? _c('i', {
    staticClass: "iconfont icon-feng-s",
    attrs: {
      "alt": ""
    }
  }) : (this.currentCmd.speed == 2) ? _c('i', {
    staticClass: "iconfont icon-feng-m",
    attrs: {
      "alt": ""
    }
  }) : _c('i', {
    staticClass: "iconfont icon-feng-b",
    attrs: {
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', [_c('flexbox', [_c('flexbox-item', [_c('div', {
    staticClass: "flex-demo"
  }, [_c('icon-button', {
    attrs: {
      "title": "model",
      "value": "mode",
      "onClick": _vm.onClick,
      "isShowTitle": true
    }
  })], 1)]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "flex-demo"
  }, [_c('icon-button', {
    attrs: {
      "title": "power",
      "value": "power",
      "onClick": _vm.onClick,
      "isShowTitle": true
    }
  })], 1)]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "flex-demo"
  }, [_c('icon-button', {
    attrs: {
      "title": "swingFlap",
      "value": "direct",
      "onClick": _vm.onClick,
      "isShowTitle": true
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-button"
  }, [_c('flexbox', [_c('flexbox-item', [_c('div', {
    staticClass: "flex-demo"
  }, [_c('div', {
    staticClass: "mb15"
  }, [_c('icon-button', {
    attrs: {
      "title": "heating",
      "value": "heating",
      "onClick": _vm.onClick,
      "isShowTitle": true
    }
  })], 1), _vm._v(" "), _c('icon-button', {
    attrs: {
      "title": "refrigeration",
      "value": "refrigeration",
      "onClick": _vm.onClick,
      "isShowTitle": true
    }
  })], 1)]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "flex-demo"
  }, [_c('volume-button', {
    attrs: {
      "title": "温度",
      "plusValue": "tempPlus",
      "subValue": "tempSub",
      "onClick": _vm.onClick
    }
  })], 1)]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "flex-demo"
  }, [_c('div', {
    staticClass: "mb15"
  }, [_c('icon-button', {
    attrs: {
      "title": "windDirection",
      "value": "windDirection",
      "onClick": _vm.onClick,
      "isShowTitle": true
    }
  })], 1), _vm._v(" "), _c('icon-button', {
    attrs: {
      "title": "airVolume",
      "value": "airVolume",
      "onClick": _vm.onClick,
      "isShowTitle": true
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('action-button', {
    attrs: {
      "totalCount": _vm.irDataList.length + 1,
      "currentHandle": _vm.current,
      "nextHandle": _vm.next,
      "preHandle": _vm.pre
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96e8c69c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/device/air/Index.vue
// module id = 918
// module chunks = 1